import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ReturnUrlService } from '@lx/quote-tool/lite/shared/services';
import { toSignal } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '@lx/shared/ui/button';
import { NavigationService } from '../../../services';
import { getDateFromString } from '@lx/shared/utils';
import { LayoutComponent } from '../../layout/layout.component';
import { NextStepsComponent } from '../../next-steps/next-steps.component';
import { OnlineQuoteToolStore } from '../../../store';
import { $localize } from '@angular/localize/init';

@Component({
  standalone: true,
  selector: 'lx-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  imports: [ButtonComponent, LayoutComponent, NextStepsComponent, NgOptimizedImage],
})
export class ConfirmationComponent {
  private readonly store = inject(OnlineQuoteToolStore);

  private readonly selectedStartDateString = toSignal(this.store.selectedStartDate$, { initialValue: '' });
  private readonly navigationService = inject(NavigationService);
  private readonly returnUrlService = inject(ReturnUrlService);

  protected readonly studentFirstName = toSignal(this.store.studentFirstName$, { initialValue: '' });

  /**
   * Transforms the selected start date string to a Date object
   * @returns Date object or undefined if the date string is empty
   */
  protected readonly courseStartDate = computed<Date | undefined>(() => {
    const dateString = this.selectedStartDateString();
    return dateString ? getDateFromString(dateString) : undefined;
  });

  // Set back button label from ReturnUrlService
  protected readonly backButtonLabel = signal<string>(this.returnUrlService.getBackButtonLabel() || $localize`Start a new quote`);

  protected onExit(): void {
    this.navigationService.closeOnlineQuoteTool();
  }
}
